import { D as r, c as o, N as n, d as s, f as t, p as f, r as d } from "./lite-BTIaQdTe.mjs";
import { continuous as c } from "./plugins.mjs";
export {
  r as Digit,
  o as canAnimate,
  c as continuous,
  n as default,
  s as define,
  t as formatToData,
  f as prefersReducedMotion,
  d as renderInnerHTML
};
